module.exports = "/_next/static/images/UDJ6-98cf882d16e1e3ddb50a5e289d8b8759.svg";